import { render } from "./ShopifyStoreDevelopment.vue?vue&type=template&id=34a5d32f&scoped=true"
import script from "./ShopifyStoreDevelopment.vue?vue&type=script&lang=js"
export * from "./ShopifyStoreDevelopment.vue?vue&type=script&lang=js"

import "./ShopifyStoreDevelopment.vue?vue&type=style&index=0&id=34a5d32f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a5d32f"]])

export default __exports__